import { LIST_FEATURE_FLAGS, useFeatureFlag } from '@diamond/shared/utils';

/**
 * Voucher display refinement is available only when both voucher menu and
 * refinement display flags are enabled.
 */
export function useVoucherDisplayEnabled(): boolean {
  const isVoucherMenuEnabled = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_VOUCHERS_MENU,
    true
  );
  const isVoucherDisplayEnabled = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_VOUCHERS_DISPLAY,
    false
  );

  return isVoucherMenuEnabled && isVoucherDisplayEnabled;
}
